module.exports = __webpack_public_path__ + "static/media/slider-l4-768.34f51835.webp";